<rt-table variant="wide">
  <thead>
    <tr>
      <th class="th-name" text-left>
        {{ title }}
      </th>
      <th class="th-type" *ngFor="let type of types; trackBy: trackByType">
        {{ typeTranslations[type] }}
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-content></ng-content>
  </tbody>
</rt-table>
